import { Injectable } from '@angular/core';

@Injectable()
export class paymentVaStorage {
    public data: any = new Array;
    public inquiryResult: any;
    public paymentResult: any;
    public imagePath: string;
    public moduleName: string;
    public modulePath: string;
    public constructor() { }
}
